export const months = [
  {
    value: '01',
    display: 'January',
    shortDisplay: 'Jan',
  },
  {
    value: '02',
    display: 'February',
    shortDisplay: 'Feb',
  },
  {
    value: '03',
    display: 'March',
    shortDisplay: 'Mar',
  },
  {
    value: '04',
    display: 'April',
    shortDisplay: 'Apr',
  },
  {
    value: '05',
    display: 'May',
    shortDisplay: 'May',
  },
  {
    value: '06',
    display: 'June',
    shortDisplay: 'Jun',
  },
  {
    value: '07',
    display: 'July',
    shortDisplay: 'Jul',
  },
  {
    value: '08',
    display: 'August',
    shortDisplay: 'Aug',
  },
  {
    value: '09',
    display: 'September',
    shortDisplay: 'Sep',
  },
  {
    value: '10',
    display: 'October',
    shortDisplay: 'Oct',
  },
  {
    value: '11',
    display: 'November',
    shortDisplay: 'Nov',
  },
  {
    value: '12',
    display: 'December',
    shortDisplay: 'Dec',
  },
];
